import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { KeKhaiTaiSan, TimKiemKeKhaiTaiSanRequest } from "../models/taisan/KeKhaiTaiSan";
import intance from "../utils/axios";

export const timKiemDSKeKhaiCaNhan = async (request: TimKiemKeKhaiTaiSanRequest, start: number, length: number) => {
    let data = {
        data: [] as KeKhaiTaiSan[],
        recordsTotal: 0,
    };

    await intance.post(ApiPaths.keKhaiTaiSan.timKiemCaNhan, {
        start,
        length,
        filter: {
            tuKhoa: request.tuKhoa || "",
            namHinhThanh: request.namHinhThanh,
            tuGiaTri: request.tuGiaTri,
            denGiaTri: request.denGiaTri,
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return data;
};

export const timKiemDSKeKhaiToanDonVi = async (request: TimKiemKeKhaiTaiSanRequest, start: number, length: number) => {
    let data = {
        data: [] as KeKhaiTaiSan[],
        recordsTotal: 0,
    };

    await intance.post(ApiPaths.keKhaiTaiSan.timKiemToanDonVi, {
        start,
        length,
        filter: {
            tuKhoa: request.tuKhoa || "",
            namHinhThanh: request.namHinhThanh,
            idNhanVien: request.idNhanVien,
            idDonVi: request.idDonVi,
            tuGiaTri: request.tuGiaTri,
            denGiaTri: request.denGiaTri,
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return data;
};

export const layChiTietKeKhai = async (id: number) => {
    let rs: KeKhaiTaiSan | null = null;

    await intance.get(`${ApiPaths.keKhaiTaiSan.layChiTiet}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
};

export const luuKeKhaiTaiSan = async (formData: FormData) => {
    let response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };

    await intance.post(ApiPaths.keKhaiTaiSan.luu, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
        .then((res) => {
            response = res.data;
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return response;
};

export const xoaKeKhaiTaiSan = async (id: number) => {
    let rs = false;

    await intance.post(`${ApiPaths.keKhaiTaiSan.xoa}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
};

export const xuatBanKeKhaiTaiSan = async (idNhanVien?: number) => {
    let rs: any;
    const url = idNhanVien ? `${ApiPaths.keKhaiTaiSan.xuatBanKeKhai}?idNhanVien=${idNhanVien}` : ApiPaths.keKhaiTaiSan.xuatBanKeKhai;
    await intance.get(url, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch(async (err) => {
            let thongBao = 'Có lỗi xảy ra khi xuất bản kê khai tài sản';
            const duLieuLoi = err?.response?.data;
            if (duLieuLoi instanceof Blob) {
                try {
                    const json = JSON.parse(await duLieuLoi.text());
                    thongBao = json?.thongBao || thongBao;
                } catch (e) {
                }
            }
            throw new Error(thongBao);
        });
    return rs;
};

